import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, createBrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import configureStore from './redux/configureStore';
import { RouterProvider } from 'react-router';

const appContainer = document.getElementById('root');
const appRoot = ReactDOM.createRoot(appContainer);

const store = configureStore;
const router = createBrowserRouter([
  {
    path: '*',
    element: <App />,
  },
]);

if (appContainer.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    appContainer,
    <Provider store={store}>
      <RouterProvider router={router} />
      {/* <BrowserRouter basename={baseUrl}>
        <App />
      </BrowserRouter > */}
    </Provider>,
  );
} else {
  appRoot.render(
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>,
  );
}

serviceWorkerRegistration.unregister();
